import React, { useEffect } from "react";
import {
  Typography,
  List,
  Radio,
  Form,
  Divider,
  Card,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const SendStep: React.FC<SendStepProps> = ({ selectedAppGroup, form }) => {
  const formRef = React.useRef<any>(null);

  useEffect(() => {
    if (formRef) {
      formRef.current = form;
    }
  }, [form]);

  const leaseholders = selectedAppGroup?.leaseDraft?.leaseholders || [];

  return (
    <Card bordered={false} style={{ width: "100%", margin: "0 auto" }}>
      <Form form={form} layout="vertical">
        <Title level={4}>Signers</Title>
        <div style={{ marginBottom: 10 }}>
          <span style={{ marginRight: 10 }}>Leaseholders</span>
          <Tooltip
            title="Residents that will sign the lease"
            style={{ fontSize: 12 }}
          >
            <InfoCircleOutlined className="ml-2 text-gray-400" />
          </Tooltip>
        </div>
        <Form.Item>
          <List
            bordered
            size="small"
            dataSource={leaseholders}
            renderItem={(item: any) => (
              <List.Item>
                <Text strong>{`${item.first_name} ${item.last_name}`}</Text>
                <Text type="secondary" style={{ marginLeft: 8 }}>
                  &lt;{item.email}&gt;
                </Text>
              </List.Item>
            )}
          />
        </Form.Item>

        <Divider />

        <Form.Item
          label="Signing Options"
          name="signingMode"
          initialValue="sequential"
          rules={[{ required: true, message: "Please select a signing mode" }]}
        >
          <Radio.Group
            style={{ display: "flex", flexDirection: "row", gap: 8 }}
          >
            <Radio value="sequential">Sequential (one after another)</Radio>
            <Radio value="parallel">Parallel (all at once)</Radio>
            <Radio value="mixed">Mixed (all residents first, then owner)</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SendStep;
